import { useState } from 'react';

/**
 * The audit field a create request carries for a price adjustment — the reason
 * the admin typed. Absent when there is no adjustment, so a normal booking
 * sends exactly what it sent before (#1942).
 */
export interface PriceAdjustmentAuditPayload {
    priceAdjustmentReason?: string;
}

/**
 * Reason capture for a price adjustment made while creating a booking.
 *
 * Room create and venue create ask the same thing of the same backend field, so
 * the state and the "only when there is an adjustment" rule live here once
 * rather than being pasted into both pages. The field itself is
 * `PriceAdjustmentReasonField`; this is the half that reaches the API.
 *
 * Who made the adjustment is NOT sent: the backend takes it from the verified
 * token (`resolveAdjustingAdminId`, #3261), never from the request body.
 *
 * @param discount the current adjustment; zero means nothing is captured or sent
 */
export const usePriceAdjustmentAudit = (discount: number) => {
    const [reason, setReason] = useState<string>('');

    // Spread into the create payload. Empty when there is no adjustment, so no
    // reason is sent for an ordinary booking.
    const payload: PriceAdjustmentAuditPayload =
        discount !== 0 ? { priceAdjustmentReason: reason } : {};

    return { reason, setReason, payload };
};
